/*
 * Copyright (c) 2017 OCLC, Inc. All Rights Reserved.
 *
 * OCLC proprietary information: the enclosed materials contain proprietary information of OCLC Online Computer
 * Library Center, Inc. and shall not be disclosed in whole or in any part to any third party or used by any person
 * for any purpose, without written consent of OCLC, Inc.  Duplication of any portion of these materials shall include
 * this notice.
 */

import React, {Component} from 'react';
import PropTypes from 'prop-types';

import Select from 'react-select';

/**
 * Allows user to select an institution from a pre-defined set of options.
 */
class InstitutionSelector extends Component {
    static propTypes = {
      institutions: PropTypes.arrayOf(PropTypes.object),
      onSelect: PropTypes.func.isRequired
    };

    static defaultProps = {
      institutions: []
    };

    constructor (props) {
      super(props);

      this.state = {
        value: undefined
      };
    }

    render () {
      return (
        <Select autoFocus
          id="institution-selector"
          options={this.props.institutions}
          valueKey="id"
          labelKey="name"
          clearable={false}
          aria-label="Institution Selector"
          placeholder=""
          searchable
          value={this.state.value}
          onChange={this.handleChange}
          optionRenderer={this.renderOption}

        />
      );
    }

    renderOption = (option) => {
      return `${option.name} - (${option.id})`;
    }

    handleChange = (newValue) => {
      console.info('Selected institution %O', newValue);
      this.setState({value: newValue});
      this.props.onSelect(newValue);
    }
}

export default InstitutionSelector;



// WEBPACK FOOTER //
// ./src/InstitutionPicker/InstitutionSelector.js